<template>
    <div class="main-app" :style="'background-color:#fff !important;margin-bottom:0;'">
        <div>
<!--             แสดง project header-->
<!--            <project-header v-if="project_detail&&(!banner_list||banner_list==0)" v-bind="{project_detail:project_detail,route_data:route_data}" class=""></project-header>-->

            <div class="" v-if="project_detail_loaded&&project_detail&&(banner_list&&banner_list.length>0)">
                <project-promotion-banner v-if="project_detail" v-bind="{project_detail:project_detail,banner_list:banner_list}" class="mt-0"></project-promotion-banner>
            </div>
            <div v-else class="pt-0 text-center">
                <v-img  v-if="event_id" :src="'https://mediacenter.lpn.co.th/images/company_internal/LPN/Event/banner/event_banner_'+event_id+'_desktop.jpg'" class="event_banner"/>
<!--                <h3 v-if="project_detail_loaded" class="my-5 text-lpn">{{ project_detail.project_name_th }}</h3>-->
            </div>

            <v-container class="container-600 ">
                <v-card color="grey lighten-4" outlined class="pa-2">
                    <div class="d-flex align-center justify-sm-center flex-sm-grow-0 my-sm-5 mb-5">
                        <div class="text-left">
                                <v-img position="left" max-width="65" contain max-height="65" :src="require('@/assets/logo.jpg')" class="event_banner"></v-img>
                        </div>
                        <div class="font-weight-bold">{{ event_project_detail.reg_title }}
                        </div>
                    </div>
                    <h3 class="blue-grey--text my-3 mt-8 ">{{ event_project_detail.reg_header }}</h3>
                    <div class="my-5" style="font-size: 0.9rem;">{{ event_project_detail.reg_sub_header }}</div>

                    <div class="font-weight-bold mt-5 mt-sm-10 mb-2" style="font-size: 0.9rem;">กรุณากรอกข้อมูลลงทะเบียน</div>

                    <v-form
                            class="mt-3"
                            v-model="valid"
                            id="nativeForm"
                            ref="nativeForm"
                            method="post"
                            action="https://lpn-backend.lpn.co.th/api/QuestionnaireDev/saveAnswer"
                            @submit="checkValid"
                            accept-charset="tis-620"
                    >
                        <input name="qj_code" id="qj_code" type="hidden" :value="qj_code"/>
                        <input name="username" id="username" type="hidden" value=""/>
                        <input name="media_refer" id="media_refer" type="hidden" :value="media_ref.ml"/>
                        <input name="media_lead" id="media_lead" type="hidden" :value="media_ref.ml"/>
                        <input name="media_lead_mt" id="media_lead_mt" type="hidden" :value="media_ref.ml_mt"/>
                        <input name="utm_source" id="utm_source" type="hidden" :value="media_ref.utm_source"/>
                        <input name="utm_medium" id="utm_medium" type="hidden" :value="media_ref.utm_medium"/>
                        <input name="gclid_field" id="gclid_field" type="hidden" :value="media_ref.gclid"/>
                        <input name="fbclid_field" id="fbclid_field" type="hidden" :value="media_ref.fbclid"/>
                        <input v-if="project_detail_loaded" name="utm_campaign" id="utm_campaign" type="hidden" :value="project_detail.project_shortname.replaceAll(/\W+/g, '-').replaceAll('---', '-')+'-'+media_ref.utm_campaign"/>

                        <input name="mkt_campaign" id="mkt_campaign" type="hidden" :value="event_project_detail.mkt_campaign"/>
                        <input name="contact_person" id="contact_person" type="hidden" :value="event_project_detail.mkt_campaign_detail"/>
<!--                        <input name="send_sms" id="send_sms" type="hidden" value="Y"/>-->

                        <v-row dense class="px-3">
                            <v-col cols="12" sm="6">
                                <v-row dense>
                                    <v-col cols="12" sm="2" class="py-0 pl-2 hidden-xs-only">ชื่อ:</v-col>
                                    <v-col cols="12" sm="10" class="pa-0">
                                        <v-text-field
                                                dense
                                                outlined
                                                placeholder="ชื่อ*"
                                                v-model="customer_name"
                                                :error-messages="customerNameErrors"
                                                @input="$v.customer_name.$touch()"
                                                @blur="$v.customer_name.$touch()"
                                                aria-autocomplete="none"
                                                name="cs_name_2"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-row dense>
                                    <v-col cols="12" sm="3" class="py-0 pl-5 hidden-xs-only">นามสกุล:</v-col>
                                    <v-col cols="12" sm="9" class="pa-0 pl-sm-2">
                                        <v-text-field
                                                dense
                                                outlined
                                                placeholder="นามสกุล*"
                                                v-model="customer_surname"
                                                :error-messages="customerSurnameErrors"
                                                @input="$v.customer_surname.$touch()"
                                                @blur="$v.customer_surname.$touch()"
                                                aria-autocomplete="none"
                                                name="cs_surname_2"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-row dense>
                                    <v-col cols="12" sm="2" class="py-0 pl-2 hidden-xs-only">อีเมล์:</v-col>
                                    <v-col cols="12" sm="10" class="pa-0">
                                        <v-text-field
                                                dense
                                                outlined
                                                placeholder="อีเมล์"
                                                v-model="customer_email"
                                                :error-messages="customerEmailErrors"
                                                @input="$v.customer_email.$touch()"
                                                @blur="$v.customer_email.$touch()"
                                                aria-autocomplete="none"
                                                name="cs_email"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="6">
                                <v-row dense>
                                    <v-col cols="12" sm="3" class="py-0 pl-5 hidden-xs-only">เบอร์โทร:</v-col>
                                    <v-col cols="12" sm="9" class="pa-0 pl-sm-2">
                                        <v-text-field
                                                dense
                                                outlined
                                                placeholder="เบอร์โทร*"
                                                v-model="customer_mobile"
                                                :error-messages="customerMobileErrors"
                                                @input="$v.customer_mobile.$touch()"
                                                @blur="$v.customer_mobile.$touch()"
                                                type="tel"
                                                maxlength="10"
                                                counter="10"
                                                aria-autocomplete="none"
                                                name="cs_mobile_2"
                                                required
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <v-row dense>
                                    <v-col cols="12" sm="12" class="py-0 pl-2 hidden-xs-only">เลือกเวลาสะดวกให้ติดต่อกลับ:</v-col>
                                    <v-col cols="12" sm="12" class="pa-0 pl-sm-2">
                                        <v-select
                                                id="time_callback_select"
                                                dense
                                                outlined
                                                placeholder="เลือกเวลาสะดวกให้ติดต่อกลับ*"
                                                v-model="time_callback"
                                                :items="time_callback_list"
                                                item-text="name"
                                                item-value="value"
                                                :error-messages="timeCallbackErrors"
                                                @change="$v.time_callback.$touch()"
                                                @blur="$v.time_callback.$touch()"
                                                required
                                        ></v-select>
                                        <input name="time_callback" id="time_callback" type="hidden" :value="time_callback"/>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="12" sm="12">
                                <div class="text-left">
                                    <a href="javascript:void(0)" @click.stop="term_dialog = true; term_view=true" style="text-decoration: none;">
                                        นโยบายความเป็นส่วนตัว <v-icon small color="blue lighten-3">mdi-help-circle</v-icon>
                                    </a>
                                    <v-checkbox
                                            v-model="term"
                                            :error-messages="termErrors"
                                            label="ยอมรับเงื่อนไขตามนโยบายความเป็นส่วนตัว"
                                            required
                                            @change="$v.term.$touch()"
                                            @blur="$v.term.$touch()"
                                            class="mt-3 d-flex justify-center"
                                    ></v-checkbox>
                                </div>
                            </v-col>
                        </v-row>
                        <div class="d-flex justify-center">
                            <v-btn
                                    type="submit"
                                    color="white--text"
                                    form="nativeForm"
                                    block
                                    style="background-color: #0d47a1"
                                    width="250"
                                    class="hidden-sm-and-up"
                            >
                                ลงทะเบียน
                            </v-btn>
                            <v-btn
                                    type="submit"
                                    color="white--text"
                                    form="nativeForm"
                                    style="background-color: #0d47a1"
                                    width="250"
                                    class="hidden-xs-only"
                            >
                                ลงทะเบียน
                            </v-btn>
                        </div>
                    </v-form>
                </v-card>

                <div id="map" class="mt-10">
                    <div class="map-title font-weight-bold" style="font-size: 0.9rem;">แผนที่</div>
                    <v-responsive :aspect-ratio="4/3" id="googleMap" class="mt-2 text-center" >
                        <iframe v-if="project_url_map" :src="project_url_map" width="100%" height="100%" frameborder="0" style="border:0;max-width: 800px;" allowfullscreen="true" aria-hidden="false" tabindex="0"></iframe>
                    </v-responsive>
                </div>

                <div id="contract" class="mt-10">
                    <div class="contact">
                        <div>
                            <div class="map-title font-weight-bold" style="font-size: 0.9rem;">สอบถามเพิ่มเติม</div>
                            <div v-if="project_detail_loaded&&project_detail.project_saleoffice_tel !== null&&project_detail.project_saleoffice_tel" class="mt-2">
                                <span class="font-weight-bold">โทร : </span>
                                <template v-for="(tel,i) in project_detail.project_saleoffice_tel.split(',')">
                                    <span v-if="i>0"> ,</span>
                                    <a :href="'tel:'+tel" class="text-dark" style="text-decoration: none !important;"><span class="contact-tel">{{  tel }}</span></a>
                                </template>
                            </div>
                            <div v-else-if="project_detail_loaded&&project_detail.project_tel!== null&&project_detail.project_tel">
                                <a :href="'tel:'+project_detail.project_tel" class="text-dark" style="text-decoration: none !important;"><span class="contact-tel">{{  project_detail.project_tel }}</span></a>
                            </div>
                            <div class="mt-1">
                                <span class="font-weight-bold">เว็บไซต์ : </span>
                                <a href="https://www.lpn.co.th/" target="_blank" class="text-dark"  style="text-decoration: none !important;"><span class="contact-website">https://www.lpn.co.th/</span></a>
                            </div>
                        </div>
                    </div>
                    <div class="social mt-4">
                        <div class="social-title font-weight-bold" style="font-size: 0.9rem;">Social Media</div>
                        <div class="social-icon-group d-flex justify-start mt-2">
                            <a href="https://www.facebook.com/condolumpiniofficial/" class="mx-2" target="_blank" data-code="fb" style="text-decoration: none !important;">
                                <v-img max-width="40" class="social-icon" :src="require('@/assets/icon/icon_fb.svg')"/>
                            </a>
                            <a href="https://www.instagram.com/condo_lumpini" class="mx-2" target="_blank" data-code="ig" style="text-decoration: none!important;">
                                <v-img max-width="40" class="social-icon" :src="require('@/assets/icon/icon_ig.svg')"/>
                            </a>
                            <a href="https://www.youtube.com/channel/UCiwRa3dD1utrDR8ucNWPU9g" class="mx-2" target="_blank" data-code="yt" style="text-decoration: none !important;">
                                <v-img max-width="40" class="social-icon" :src="require('@/assets/icon/icon_yt.svg')"/>
                            </a>
                        </div>
                    </div>
                </div>

            </v-container>

        </div>


        <v-dialog
                v-model="term_dialog"
                max-width="700"
        >
            <v-card>
                <!--                <v-card-title class="headline">{{ form_lang_data.term_link_text }}</v-card-title>-->
                <v-card-text v-html="term_detail_text" class="pt-5">
                </v-card-text>

                <v-card-actions class="d-flex justify-center">
                    <div class="text-center">
                        <v-btn color="green darken-1" class="white--text" @click="term_dialog = false; term_read = true">
                            รับทราบ
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Google Tag Manager (noscript) : Lead Page for www.LPN.co.th -->
        <noscript>
            <div v-if="project_detail_loaded" v-html="this.event_project_detail.gg_body_noscript"></div>
        </noscript>
        <!-- End Google Tag Manager (noscript) -->

        <!-- Faceboook (noscript) : Lead Page for www.LPN.co.th -->
        <noscript>
            <div v-if="project_detail_loaded" v-html="this.event_project_detail.fb_body_noscript"></div>
        </noscript>
        <!-- End Faceboook (noscript) -->


    </div>
</template>

<script>

    import ProjectHeader from '@/components/saleOnline/ProjectHeader'
    import ProjectPromotionBanner from '@/components/saleOnline/ProjectPromotionBanner'

    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'

    import { required, email,numeric,minLength,maxLength } from 'vuelidate/lib/validators'

    import {_} from 'vue-underscore';

    // import '@/plugins/gtm.js'

    export default {
        name: "ProjectDetail",
        components:{
            projectPromotionBanner:ProjectPromotionBanner,
            projectHeader:ProjectHeader,
            Swiper,
            SwiperSlide
        },
        data(){
            return{
                current_loading_state:{
                    show:false,
                    message:'กำลังโหลดข้อมูล....กรุณารอสักครู่.',
                    progressColor:'blue'
                },
                // route_data: null,
                project_id:null,
                project_detail: null,
                project_url_map: null,
                brand_color:'#16448f',
                banner_list:null,
                isCountdown:false,
                event_start: null,
                event_id: null,
                event_name: '',
                qj_code: null,
                project_detail_loaded:false,
                event_project_detail:{},
                media_ref: {
                    ml: '',
                    ml_mt: '',
                    utm_source: '',
                    utm_medium: '',
                    utm_campaign: '',
                    gclid: '',
                    fbclid: '',
                },
                valid: false,
                customer_name:'',
                customer_surname:'',
                customer_email:'',
                customer_mobile:'',
                time_callback:'',
                time_callback_list:[
                    {name:"โทรกลับทันที",value:"โทรกลับทันที"},
                    {name:"10:00 - 12:00 น.",value:"10:00 - 12:00 น."},
                    {name:"12:00 - 13:00 น.",value:"12:00 - 13:00 น."},
                    {name:"13:00 - 15:00 น.",value:"13:00 - 15:00 น."},
                    {name:"15:00 - 18:00 น.",value:"15:00 - 18:00 น."},
                    {name:"18:00 - 19:00 น.",value:"18:00 - 19:00 น."},
                ],
                term_dialog:false,
                term: false,
                term_view: false,
                term_read: false,
                term_detail_text:'<div class="container-fluid box">\n' +
                    '<div class="row">\n' +
                    '<h1 class="psl_kandabold navyblue center">นโยบายความเป็นส่วนตัว</h1>\n' +
                    '</div>\n' +
                    '<div class="row THSarabunPSK fontsize-ctrl row-ctrl">\n' +
                    '<div class="col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">\n' +
                    '<p><strong>การเก็บรวบรวมข้อมูลส่วนบุคคล</strong></p>\n' +
                    '<ol style="list-style: outside none decimal;">\n' +
                    '    <li>\n' +
                    '    เพื่อความสะดวกในการให้บริการแก่ผู้ใช้บริการทุกท่านที่แวะมายังเว็บไซต์ www.lpn.co.th\n' +
                    '    ทางเว็บไซต์จึงได้จัดเก็บรวบรวมข้อมูลส่วนบุคคลของท่านไว้ เช่น อีเมลแอดเดรส (Email Address)\n' +
                    '    ชื่อ (Name) ที่อยู่หรือที่ทำงาน (Home or Work Address)&nbsp; รหัสไปรษณีย์ (ZIP Code)\n' +
                    '    หรือหมายเลขโทรศัพท์ (Telephone Number) เป็นต้น\n' +
                    '    </li>\n' +
                    '    <li>\n' +
                    '    ในกรณีที่ท่านสมัคร (Sign up) เพื่อสมัครสมาชิกหรือเพื่อใช้บริการอย่างใดอย่างหนึ่ง\n' +
                    '    เว็บไซต์ จะเก็บรวบรวม ข้อมูล ส่วนบุคคลของท่านเพิ่มเติม ได้แก่ เพศ (Gender) อายุ\n' +
                    '    (Age) สิ่งที่โปรดปราน/ความชอบ (Preferences/Favorites) ความสนใจ\n' +
                    '    (Interests) หรือหมายเลขบัตรเครดิต (Credit Card Number)\n' +
                    '    และที่อยู่ในการแจ้งค่าใช้จ่าย (Billing Address)\n' +
                    '    </li>\n' +
                    '    <li>\n' +
                    '    นอกจากนั้น เพื่อสำรวจความนิยมในการใช้บริการ อันจะเป็นประโยชน์ในการนำสถิติไปใช้ในการปรับปรุงคุณภาพในการให้บริการทางเว็บไซต์\n' +
                    '    จึงจำเป็นต้องจัดเก็บรวบรวมข้อมูลของท่านบางอย่างเพิ่มเติมด้วย ได้แก่ หมายเลขไอพี (IP Address) ชนิดของโปรแกรมค้นผ่าน\n' +
                    '    (Browser Type) ชื่อโดเมน (Domain Name) บันทึกหน้าเว็บ (web page) ของเว็บไซต์ที่ผู้ใช้เยี่ยมชมเวลาที่เยี่ยมชมเว็บไซต์\n' +
                    '    (Access Times) และเว็บไซต์ที่ผู้ใช้บริการเข้าถึงก่อนหน้านั้น (Referring Website Addresses)\n' +
                    '    </li>\n' +
                    '    <li>\n' +
                    '    ทางเว็บไซต์ ขอแนะนำให้ท่านตรวจสอบนโยบายความเป็นส่วนตัวของเว็บไซต์อื่นที่เชื่อมโยงจากเว็บไซต์นี้ เพื่อจะได้ทราบและเข้าใจว่าเว็บไซต์ดังกล่าวเก็บรวบรวม\n' +
                    '    ใช้ หรือดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่านอย่างไร ทั้งนี้บริษัท แอล.พี.เอ็น.ดีเวลลอปเมนท์ จำกัด (มหาชน)\n' +
                    '    ไม่สามารถรองรับข้อความหรือรับรองการดำเนินการตามที่ได้มีการประกาศไว้ในเว็บไซต์ดังกล่าวได้ และไม่ขอรับผิดชอบใดๆ\n' +
                    '    หากเว็บไซต์เหล่านั้นไม่ได้ปฏิบัติการหรือดำเนินการใดๆ ตามนโยบายความเป็นส่วนตัวที่เว็บไซต์ดังกล่าวได้ประกาศไว้\n' +
                    '    </li>\n' +
                    '</ol>\n' +
                    '</div>\n' +
                    '</div>\n' +
                    '<div class="row THSarabunPSK fontsize-ctrl row-ctrl">\n' +
                    '<div class="col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">\n' +
                    '<p><strong>การใช้ข้อมูลส่วนตัว</strong></p>\n' +
                    '<ol style="list-style: outside none decimal;">\n' +
                    '    <li>\n' +
                    '    ทางเว็บไซต์ จะใช้ข้อมูลส่วนบุคคลของท่านเพียงเท่าที่จำเป็น เช่น ชื่อ และที่อยู่ เพื่อใช้ในการติดต่อ ให้บริการ ประชาสัมพันธ์หรือให้ข้อมูลข่าวสารต่างๆ\n' +
                    '    รวมทั้งสำรวจความคิดเห็นของท่านในกิจการหรือกิจกรรมของ บริษัท แอล.พี.เอ็น.ดีเวลลอปเมนท์ จำกัด (มหาชน) เท่านั้น\n' +
                    '    </li>\n' +
                    '    <li>\n' +
                    '    ทางเว็บไซต์ ขอรับรองว่าจะไม่นำข้อมูลส่วนบุคคลของท่าน ที่ทางเว็บไซต์ได้เก็บรวบรวมไว้\n' +
                    '    ไปขายหรือเผยแพร่ให้กับบุคคลภายนอกโดยเด็ดขาด เว้นแต่จะได้รับอนุญาตจากท่านเท่านั้น\n' +
                    '    </li>\n' +
                    '    <li>\n' +
                    '    ในกรณีที่ได้ว่าจ้างหน่วยงานอื่นเพื่อให้ดำเนินการเกี่ยวกับข้อมูลส่วนบุคคลของท่าน เช่น การจัดส่งพัสดุไปรษณีย์\n' +
                    '    การวิเคราะห์เชิงสถิติในกิจการหรือกิจกรรมของทางเว็บไซต์ เป็นต้น ทางเว็บไซต์ จะกำหนดให้หน่วยงานที่ได้ว่าจ้างให้ดำเนินการดังกล่าว\n' +
                    '    เก็บรักษาความลับและความปลอดภัยของข้อมูลส่วนบุคคลของท่านและกำหนดข้อห้ามมิให้มีการนำข้อมูลส่วนบุคคลดังกล่าวไปใช้นอกเหนือจากกิจกรรมหรือกิจการของ\n' +
                    '    บริษัท แอล.พี.เอ็น.ดีเวลลอปเมนท์ จำกัด (มหาชน)\n' +
                    '    </li>\n' +
                    '</ol>\n' +
                    '</div>\n' +
                    '</div>\n' +
                    '<div class="row THSarabunPSK fontsize-ctrl row-ctrl">\n' +
                    '<div class="col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">\n' +
                    '<p><strong>สิทธิในการควบคุมข้อมูลส่วนบุคคลของท่าน</strong></p>\n' +
                    '<p>บริษัท แอล.พี.เอ็น.ดีเวลลอปเมนท์ จำกัด (มหาชน) ได้จัดทำนโยบายคุ้มครองความเป็นส่วนตัวฉบับนี้ขึ้น เพื่อคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการทุกท่าน (Personal Information) ที่ติดต่อเข้ามายังเว็บไซต์ www.lpn.co.th ดังนี้</p>\n' +
                    '<ul style="list-style: inside none disc;padding-left: 0;">\n' +
                    '    <br>\n' +
                    '    <p><strong>การรักษาความปลอดภัยสำหรับข้อมูลส่วนบุคคล</strong></p>\n' +
                    '    <p>\n' +
                    '    เพื่อประโยชน์ในการรักษาความลับและความปลอดภัยสำหรับข้อมูลส่วนบุคคลของท่าน ทางเว็บไซต์\n' +
                    '    จึงได้กำหนดระเบียบภายในหน่วยงานเพื่อกำหนดสิทธิในการเข้าถึงหรือใช้ข้อมูลส่วนบุคคลของท่าน\n' +
                    '    และเพื่อรักษาความลับและความปลอดภัยของข้อมูลบางอย่างที่มีความสำคัญอย่างยิ่ง เช่น หมายเลขบัตรเครดิต เป็นต้น\n' +
                    '    ทางเว็บไซต์ จึงได้จัดให้มีช่องทางการสื่อสารแบบปลอดภัยสำหรับข้อมูลดังกล่าวด้วยการเข้ารหัสลับข้อมูลดังกล่าว\n' +
                    '    เช่น จัดให้มีการใช้ Secure Socket Layer (SSL) protocol เป็นต้น\n' +
                    '    </p>\n' +
                    '    <br>\n' +
                    '    <p><strong>การใช้คุกกี้ (Cookies)</strong></p>\n' +
                    '    <p>\n' +
                    '    “คุกกี้” คือ ข้อมูลที่ ทางเว็บไซต์ ส่งไปยังโปรแกรมค้นผ่านเว็บไซต์ (Web browser) ของผู้ใช้บริการ และเมื่อมีการติดตั้งข้อมูลดังกล่าวไว้ในระบบของท่านแล้ว\n' +
                    '    หากมีการใช้ “คุกกี้” ก็จะทำให้เว็บไซต์ สามารถบันทึกหรือจดจำข้อมูลของผู้ใช้บริการไว้ จนกว่าผู้ใช้บริการจะออกจากโปรแกรมค้นผ่านเว็บไซต์ หรือจนกว่าผู้ใช้บริการจะทำการลบ\n' +
                    '    “คุกกี้” นั้นเสีย หรือไม่อนุญาตให้ “คุกกี้” นั้นทำงานต่อไปหากท่านเลือกใช้ “คุกกี้” แล้ว ท่านจะได้รับความสะดวกสบายในการท่องเว็บไซต์มากขึ้น เพราะ “คุกกี้”\n' +
                    '    จะช่วยจดจำเว็บไซต์ที่ท่านแวะ, เยี่ยมชม หรือท่องเว็บไซต์ ทั้งนี้ทางเว็บไซต์ จะนำข้อมูลที่ “คุกกี้” ได้บันทึกหรือเก็บรวบรวมไว้ไปใช้ในการวิเคราะห์เชิงสถิติ หรือในกิจกรรมอื่นของ\n' +
                    '    บริษัท แอล.พี.เอ็น.ดีเวลลอปเมนท์ จำกัด (มหาชน) เพื่อปรับปรุงคุณภาพการให้บริการของทางบริษัทต่อไป\n' +
                    '    </p>\n' +
                    '</ul>\n' +
                    '</div>\n' +
                    '</div>\n' +
                    '<div class="row THSarabunPSK fontsize-ctrl row-ctrl">\n' +
                    '<div class="col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">\n' +
                    '<p><strong>การปรับปรุงนโยบายความเป็นส่วนตัว</strong></p>\n' +
                    '<p>บริษัท แอล.พี.เอ็น.ดีเวลลอปเมนท์ จำกัด (มหาชน) อาจทำการปรับปรุงหรือแก้ไขนโยบายความเป็นส่วนตัว โดยไม่ได้แจ้งให้ท่านทราบล่วงหน้า ทั้งนี้เพื่อความเหมาะสมและมีประสิทธิภาพในการให้บริการ ดังนี้จึงขอแนะนำให้ผู้ใช้บริการอ่านนโยบายความเป็นส่วนตัวทุกครั้งที่แวะชม หรือเยี่ยมชม หรือมีการใช้บริการจากเว็บไซต์ www.lpn.co.th</p>\n' +
                    '</div>\n' +
                    '</div>\n' +
                    '<div class="row THSarabunPSK fontsize-ctrl row-ctrl">\n' +
                    '<div class="col-xs-10 col-xs-offset-1 col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">\n' +
                    '<p><strong>การปฏิบัติตามนโยบายความเป็นส่วนตัวและการติดต่อกลับ (หน่วยงาน/เว็บไซต์)</strong></p>\n' +
                    '<p>ในกรณีที่ท่านมีข้อสงสัย ข้อเสนอแนะ หรือข้อติชมใดๆ เกี่ยวกับนโยบายความเป็นส่วนตัว หรือการปฏิบัติ ตามนโยบายความเป็นส่วนตัวฉบับนี้ทางเว็บไซต์ยินดีที่จะตอบข้อสงสัยรับฟังข้อเสนอแนะ และคำติชมทั้งหลาย อันจะเป็นประโยชน์ต่อการปรับปรุง การให้บริการของ บริษัท แอล.พี.เอ็น.ดีเวลลอปเมนท์ จำกัด (มหาชน) ต่อไป โดยท่านสามารถติดต่อได้ที่ <a href="https://www.lpn.co.th/%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B9%88%E0%B8%AD/%E0%B8%95%E0%B8%B4%E0%B8%94%E0%B8%95%E0%B9%88%E0%B8%AD%E0%B9%80%E0%B8%A3%E0%B8%B2" target="_blank">Contact Us</a></p>\n' +
                    '</div>\n' +
                    '</div>\n' +
                    '</div>',
                uid:'',
            }
        },
        async mounted(){

            window.scrollTo(0,0)
            //แสดง loading
            this.current_loading_state.show = true
            store.commit('changeLoadingState', this.current_loading_state)

            if(this.$route.query.hasOwnProperty('ev_id')){
                this.event_id = this.$route.query.ev_id
            }
            if(this.$route.query.hasOwnProperty('qj_code')){
                this.qj_code = this.$route.query.qj_code
            }
            if(this.$route.query.hasOwnProperty('ml')){
                this.media_ref.ml = this.$route.query.ml
            }
            if(this.$route.query.hasOwnProperty('ml_mt')){
                this.media_ref.ml_mt = this.$route.query.ml_mt
            }
            if(this.$route.query.hasOwnProperty('utm_source')){
                this.media_ref.utm_source = this.$route.query.utm_source
            }
            if(this.$route.query.hasOwnProperty('utm_medium')){
                this.media_ref.utm_medium = this.$route.query.utm_medium
            }
            if(this.$route.query.hasOwnProperty('utm_campaign')){
                this.media_ref.utm_campaign = this.$route.query.utm_campaign
            }
            if(this.$route.query.hasOwnProperty('gclid')){
                this.media_ref.gclid = this.$route.query.gclid
            }
            if(this.$route.query.hasOwnProperty('fbclid')){
                this.media_ref.fbclid = this.$route.query.fbclid
            }
            if(this.$route.query.hasOwnProperty('uid')){
                this.uid = this.$route.query.uid
                const customerProfile = await this.getCustomerInfo(this.uid)
                if(customerProfile){
                    this.customer_name = customerProfile.CR_FIRST_NAME
                    this.customer_surname = customerProfile.CR_LAST_NAME
                    this.customer_email = customerProfile.CR_EMAIL
                    this.customer_mobile = customerProfile.CR_PHONE_NUMBER
                }
            }

            // let event_data = this.getSavedLocalItem('lla_event')
            //
            // if(event_data&&event_data.hasOwnProperty('event_name')&&event_data.event_id==this.event_id){
            //     this.event_name = event_data.event_name
            // }else {
                let event_data = await this.getProjectList()

                if(event_data.length&&event_data[0].hasOwnProperty('ev_name')) {
                    this.event_start = event_data[0]?.ev_start
                    this.event_name = event_data[0]?.ev_name

                    if(!this.qj_code){
                        this.qj_code = event_data[0]?.qj_code
                    }

                    localStorage.setItem('lla_event', JSON.stringify({event_name:this.event_name,event_start:this.event_start}))
                }else{
                    console.log('event_id is empty')
                    // main-app
                    this.$nextTick(() => {
                        document.querySelector('.main-app').innerHTML = "<div class='v-alert red white--text' style='border-radius: unset;'>Error loading!  ...... Event not found.</div>"
                    })
                }
            // }

            //change this to get project details by project_id params from API
            // const local_project_detail = this.getSavedLocalItem(this.local_project_key)
            // if(local_project_detail&&local_project_detail.hasOwnProperty('project_id')&&local_project_detail.project_id==this.project_id){
            //    this.project_detail = local_project_detail
            // }else {
                this.project_detail = await this.getProjectDetails(this.project_id)
                this.saveSelectedProject(this.project_detail)
            // }

            this.brand_color = this.getProjectColor(this.project_detail.project_shortname)
            this.banner_list = await this.getBannerList()
            // console.log(this.banner_list)

            this.event_project_detail = await this.getEventProjectDetail()

            this.$nextTick(() => {
                // this.route_data = this.genRouteData
                this.isCountdown = true
                this.project_detail_loaded = true
                this.project_url_map = this.project_detail.project_url_map
                // this.event_start = this.project_list[0]?.ev_start
            })

            //ซ่อน loading
            this.current_loading_state.show = false
            store.commit('changeLoadingState', this.current_loading_state)
        },
        metaInfo() {
            return {
                title: this.event_name + ' | '+ (this.project_detail_loaded ? this.project_detail.project_name_th:''),
                titleTemplate: '%s - LPN Register',
                script: [
                    { innerHTML: (this.event_project_detail.fb_head_script ? this.event_project_detail.fb_head_script:''), type: 'text/javascript', charset: 'utf-8'},
                    { innerHTML: "",src: (this.event_project_detail.gg_head_import_script ? this.event_project_detail.gg_head_import_script:''), async: true},
                    { innerHTML: (this.event_project_detail.gg_head_script ? this.event_project_detail.gg_head_script:''), type: 'text/javascript', charset: 'utf-8'},
                    { innerHTML: '',src: 'https://connect-x-back-production.herokuapp.com/connectx/api/webTrackingSdk.min.js?orgId=S3wEgG66t7KE3V4I5wq1',id:'connectxWebTracking'},
                ],
            };
        },
        validations: {
            customer_name:{
                required,
            },
            customer_surname:{
                required,
            },
            customer_email:{
                // required,
                email
            },
            customer_mobile:{
                required,
                numeric,
                minLength:minLength(10),
                maxLength:maxLength(10),
            },
            time_callback:{
                required
            },
            term:{
                checked (val) {
                    return val
                },
            },
        },
        computed: {
            customerNameErrors () {
                const errors = []
                if (!this.$v.customer_name.$dirty) return errors
                !this.$v.customer_name.required && errors.push('โปรดระบุ "ชื่อ"')
                return errors
            },
            customerSurnameErrors () {
                const errors = []
                if (!this.$v.customer_surname.$dirty) return errors
                !this.$v.customer_surname.required && errors.push('โปรดระบุ "นามสกุล"')
                return errors
            },
            customerEmailErrors () {
                const errors = []
                if (!this.$v.customer_email.$dirty) return errors
                // !this.$v.customer_email.required && errors.push('โปรดระบุ "อีเมล์"')
                !this.$v.customer_email.email && errors.push('รูปแบบของ "อีเมล์" ไม่ถูกต้อง')
                return errors
            },
            customerMobileErrors () {
                const errors = []
                if (!this.$v.customer_mobile.$dirty) return errors
                !this.$v.customer_mobile.required && errors.push('โปรดระบุ "เบอร์โทรศัพท์"')
                !this.$v.customer_mobile.numeric && errors.push('"เบอร์โทรศัพท์" ต้องเป็นตัวเลขเท่านั้น')
                !this.$v.customer_mobile.minLength && errors.push('โปรดระบุ "เบอร์โทรศัพท์" 10 หลัก')
                !this.$v.customer_mobile.maxLength && errors.push('โปรดระบุ "เบอร์โทรศัพท์" 10 หลัก')
                return errors
            },
            timeCallbackErrors () {
                const errors = []
                if (!this.$v.time_callback.$dirty) return errors
                !this.$v.time_callback.required && errors.push('โปรดระบุ "เวลาที่สะดวกให้ติดต่อกลับ"')
                return errors
            },
            termErrors () {
                const errors = []
                if (!this.$v.term.$dirty) return errors
                !this.$v.term.checked && errors.push('โปรดเลือก ยอมรับเงื่อนไขตามนโยบายความเป็นส่วนตัว')
                return errors
            },
            // genRouteData() {
            //     const data = {
            //         back_route: {
            //             name: 'saleOnline_projectDetail',
            //             params: {project_id: (this.project_detail ? this.project_detail.project_id : 0)}
            //         }
            //     }
            //     return data
            // },
        },
        created() {

            //แสดงเลข version
            store.commit('changeShowVersionState', false)

            //แสดงเมนูด้านล่าง และกำหนดรายการเมนู
            this.setBottomNav(false)

            this.setTopNav(
                false,
            )

            if(this.$route.query.hasOwnProperty('pj')){
                this.project_id = this.$route.query.pj
            }


            //ซ่อน flash massage
            store.commit('changeFlashState',{show:false})

        },
        methods:{
            async getProjectList(){
                //แสดง loading
                this.current_loading_state.show = true
                store.commit('changeLoadingState', this.current_loading_state)

                const requestBody = {
                    ev_id: this.event_id,
                    project_id: this.project_id
                }

                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getEventProjectList', requestBody))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result]
                        // this.project_list = [...promiseChecking.result.res.data.result]
                    }
                }

                //ซ่อน loading
                this.current_loading_state.show = false
                store.commit('changeLoadingState', this.current_loading_state)

                return finalResult

            },
            async checkValid(e){
                this.$v.$touch()
                if(!this.$v.$invalid){

                    console.log("prepare save consent")
                    let consent_id = await this.saveConsent()
                    console.log("finished save consent",consent_id)
                    return true
                }else{
                    console.log("invalid form data")
                }

                e.preventDefault()
                return false
            },
            async getEventProjectDetail(){
                //แสดง loading
                this.current_loading_state.show = true
                store.commit('changeLoadingState', this.current_loading_state)

                const requestBody = {
                    ev_id: this.event_id,
                    project_id: this.project_id
                }

                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getEventProjectList', requestBody))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.res.data.code == '000') {
                        finalResult = [...promiseChecking.result.res.data.result][0]
                    }
                }

                //ซ่อน loading
                this.current_loading_state.show = false
                store.commit('changeLoadingState', this.current_loading_state)

                return finalResult

            },
            async saveConsent(){
                const post_data = {
                    qj_code:this.qj_code,
                    username:'',
                    media_refer:this.media_ref.ml,
                    media_lead:this.media_ref.ml,
                    media_lead_mt:this.media_ref.ml_mt,
                    utm_source:this.media_ref.utm_source,
                    utm_medium:this.media_ref.utm_medium,
                    utm_campaign:this.media_ref.utm_campaign,
                    send_sms:'Y',
                    cs_name_2:this.customer_name?.trim(),
                    cs_surname_2:this.customer_surname?.trim(),
                    cs_email:this.customer_email?.trim(),
                    cs_mobile_2:this.customer_mobile?.trim(),
                    time_callback:this.time_callback,
                    term:this.term ? 'Y':'N',
                    term_view:this.term_view ? 'Y':'N',
                    term_read:this.term_read ? 'Y':'N',
                    consent_title:"ขอการเก็บข้อมูลเพื่อใช้ในการสื่อสารการตลาด",
                    current_url:window.location.href,
                    user_agent:navigator.userAgent,
                    project_id: this.project_id,
                    event_id: this.event_id
                }

                console.log(post_data)

                store.commit('changeLoadingState', {
                    show:true,
                    message:'กำลังบันทึกข้อมูล....กรุณารอสักครู่.',
                    progressColor:'blue'
                })

                //save consent
                let promiseChecking, consent_id = ''

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/saveRegConsent', post_data,true))

                if (!promiseChecking.error) {
                    if (promiseChecking.result.status=='success'&&promiseChecking.result.res.data.code == '000') {
                        consent_id = promiseChecking.result.res.data.result
                    }else{
                       console.log("ไม่สามารถบันทึก consent ได้")
                    }
                }else{
                    console.log("ไม่สามารถบันทึก consent ได้")
                }

                store.commit('changeLoadingState', {show:false})

                return consent_id
            },
            //dynamic get Banner from API
            async getBannerList(){
                // let project_images = await this.getProjectImages()
                //
                // let project_banner = project_images ? project_images.filter(n =>
                //     ['banner'].indexOf(n.pj_image_category)>-1
                // ):{}

                const requestBody = {
                    project_id: this.project_id,
                    tag_name: this.event_name
                }

                let promiseChecking, finalResult = null

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getBannerList',requestBody,true,'json'))

                if (!promiseChecking.error) {
                    if(promiseChecking.result.res.data.code=='000'){
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }

                if(finalResult&&finalResult.length>0){
                    return _.sortBy(
                        finalResult.map((item) => {
                            item.banner_sort = item.banner_sort ? item.banner_sort*1:null
                                return item
                            })
                            ,'banner_sort'
                        )
                }

                // if(!finalResult){
                //     finalResult = []
                // }
                // project_banner.forEach(item => {
                //     // console.log(item)
                //     finalResult.unshift(
                //     // finalResult.push(
                //         {
                //             banner_source_url: item.pj_image_link,
                //             banner_name: this.project_detail.project_name_th,
                //         }
                //     )
                // })

                return finalResult
            },
            async getProjectImages(){
                const requestBody = {
                    project_id:this.project_detail.project_id
                }

                let promiseChecking, finalResult = []

                promiseChecking = await this.promiseHandle(this.PostHttp('Readytomove/getProjectImages',requestBody,true,'json'))

                if (!promiseChecking.error) {
                    if(promiseChecking.result.res.data.code=='000'){
                        finalResult = [...promiseChecking.result.res.data.result]
                    }
                }
                return finalResult
            },
            arrayGroupBy(array, key) {
                const result = {}
                array.forEach(item => {
                    if (!result[item[key]]) {
                        result[item[key]] = []
                    }
                    result[item[key]].push(item)
                })

                return result
            },
            scrollToDiv(elem_id){
                let container = this.$el.querySelector(elem_id);
                container.scrollIntoView()
            }
        }

    }
</script>

<style scoped>
    .event_banner{
        max-width: 900px;
        margin: auto;
    }

</style>
